(function(){
  if(window.__MRWISH_CART_V10__) return;
  window.__MRWISH_CART_V10__=true;

  var NAMES=['01 Floral Wine','02 Rainy Eaves','03 Desire Bay','04 Shimmering Silk','05 Begonia Stone','06 Ebony Rose','07 Morning Dew','08 Provence Truffle','09 Sapphire Lagoon','10 Terracotta Rose','11 Frosted Sugar','12 Rose Sand','13 Shadow Turquoise','14 Golden Amber','15 Moonlight Violet','16 Glowing Peach','17 Plum Velvet','18 Crystal Wine','19 Crystal Stardust','20 Sakura Tears','21 Mint Mambo','22 Blue Iceland','23 Misty Rain','24 Aurora Blush','25 Autumn Amber'];
  var IDS=[54104643109205,54104643141973,54104643174741,54104643207509,54104643240277,54104643273045,54104643305813,54104643338581,54104643371349,54104643404117,54104643436885,54104643469653,54104643502421,54104643535189,54104643567957,54104643600725,54104643633493,54104643666261,54104643699029,54104643731797,54104643764565,54104643797333,54104643830101,54104643862869,54104643895637];
  var VARIANT_MAP={};
  NAMES.forEach(function(n,i){ VARIANT_MAP[n]=IDS[i]; });
  var GIFT_ID=54104576557397;

  // Read only the selected pack; collapsed packs still occupy layout space.
  function selectedPack(btn){
    var scope=btn.closest('[id^="MainProduct-"]') || btn.closest('.shopify-section');
    if(!scope) return null;
    var radio=scope.querySelector('quantity-breaks input[type="radio"]:checked');
    if(!radio) return null;
    var labels=radio.closest('quantity-breaks').querySelectorAll('label.quantity-break');
    for(var i=0;i<labels.length;i++){
      if(labels[i].htmlFor===radio.id) return labels[i];
    }
    return null;
  }

  function selectedColors(pack){
    var colors=[];
    pack.querySelectorAll('.quantity-break__selector-item select').forEach(function(select){
      if(VARIANT_MAP[select.value]) colors.push(select.value);
    });
    return colors;
  }

  function addBundle(e,btn){
    var pack=selectedPack(btn);
    if(!pack) return;
    var qty=Number(pack.dataset.quantity);
    if(qty < 2 || !Number.isInteger(qty)) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var colors=selectedColors(pack);

    if(colors.length !== qty){
      alert('Please choose '+qty+' colors.');
      return;
    }

    var items=colors.map(function(color){
      return { id:Number(VARIANT_MAP[color]), quantity:1, properties:{'Selected Color':color} };
    });

    if(qty >= 5 && GIFT_ID){
      items.push({
        id:Number(GIFT_ID),
        quantity:1,
        properties:{'FREE GIFT':'Rechargeable Nail Magnet Light','_free_gift':'Free with 5 Pens'}
      });
    }

    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:items})
    }).then(function(response){
      if(!response.ok){
        return response.text().then(function(text){
          alert('Bundle could not be added. Shopify: '+text);
        });
      }
      window.location.href='/cart';
    });
  }

  document.addEventListener('click', function(e){
    var btn=e.target.closest('button[name="add"], .product-form__submit, .main-product-atc');
    if(btn) addBundle(e,btn);
  }, true);
})();
